import React from 'react';
import { bonuses } from '../data/modules';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  return <section className="px-4 py-8" data-id="element-26" data-mp="1of2ea2x0qe9o">
      <div className="mx-auto max-w-4xl" data-id="element-27" data-mp="1oi81tdq0183a">
        <h2 className="text-center font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-28" data-mp="22fwmakg5md7t">
          🎁 In più riceverai 5 bonus esclusivi
        </h2>

        <ul className="mt-4 space-y-3" data-id="element-29" data-mp="1aogvsfbh86cb">
          {bonuses.map(bonus => <li key={bonus.label} className="rounded-xl border-l-4 border-mustard bg-white p-4 shadow-[0_1px_0_rgba(143,165,138,0.35)]" data-id="element-30" data-mp="1amctg1t87fe5">
              <p className="font-display text-[11px] font-extrabold uppercase tracking-[0.12em] text-mustard sm:text-xs" data-id="element-31" data-mp="1jiby7fl7rio9">
                {bonus.label}
              </p>
              <h3 className="mt-0.5 font-display text-[15px] font-extrabold uppercase leading-tight sm:text-lg" data-id="element-32" data-mp="qzoi6el2qtu1">
                {bonus.title}
              </h3>
              <p className="mt-1 text-[13px] leading-snug text-graphite sm:text-sm" data-id="element-33" data-mp="29s31pccn5la4">
                {bonus.description}
              </p>
            </li>)}
        </ul>

        <CTAButton className="mx-auto mt-5 max-w-lg" data-id="element-34" data-mp="2ep37rn9hqo18" />
      </div>
    </section>;
}